import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';

import { svgStringToHTML } from '@/utils/svgStringToHTML';

import styles from './QualityMetricScale.module.scss';

interface QualityMetricViewProps {
  title?: string;
  pathName: string;
}

function QualityMetricScale(props: QualityMetricViewProps) {
  const { title, pathName } = props;

  const [svgContent, setSvgContent] = useState<Nullable<string>>(null);

  async function getMetric() {
    const params = new URLSearchParams();

    if (title) {
      params.append('grade', title);
      params.append('rs', '1');
    }

    try {
      const svgElement = await svgStringToHTML(`${import.meta.env.MR_SCALE_ORIGIN}/grade/${pathName}?${params.toString()}`);

      setSvgContent(svgElement?.outerHTML ?? null);
    } catch (e) {
      //
    }
  }

  useEffect(() => {
    getMetric();
  }, []);

  if (!svgContent) {
    return null;
  }

  return <div className={styles.root} dangerouslySetInnerHTML={{ __html: svgContent }} />;
}

export default observer(QualityMetricScale);
